import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi500 } from "../../../../styles/font.constants";

export const InputLabel = styled.div`
	${satoshi500}
	font-size: 0.875rem;
	color: ${colours.black};
	margin-bottom: 0.4rem;
`;
